import React, { useState, useContext, useEffect, useMemo, useCallback, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import clsx from "clsx";
import {
  makeStyles,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  Button,
  MenuItem,
  IconButton,
  Menu,
  useTheme,
  useMediaQuery,
  Avatar,
  Badge,
  withStyles,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import NotificationsIcon from "@material-ui/icons/Notifications";
import CachedIcon from "@material-ui/icons/Cached";
import api from "../services/api";
import MainListItems from "./MainListItems";
import NotificationsPopOver from "../components/NotificationsPopOver";
import PlanLimitsSiren from "../components/PlanLimitsSiren/index.js";
import NotificationsVolume from "../components/NotificationsVolume";
import UserModal from "../components/UserModal";
import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import { i18n } from "../translate/i18n";
import toastError from "../errors/toastError";
import AnnouncementsPopover from "../components/AnnouncementsPopover";
import BirthdayModal from "../components/BirthdayModal";
import logo from "../assets/logo.png";
import logoDark from "../assets/logo-black.png";
import ChatPopover from "../pages/Chat/ChatPopover";
import { useDate } from "../hooks/useDate";
import ColorModeContext from "../layout/themeContext";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import TranslateIcon from "@material-ui/icons/Translate";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { Popover } from "@material-ui/core";
import { getBackendUrl } from "../config";
import useSettings from "../hooks/useSettings";
import VersionControl from "../components/VersionControl";
import useSocketListener from "../hooks/useSocketListener";
import { FaGlobe } from "react-icons/fa";
import BRFlag from "../assets/brazil.png";
import USFlag from "../assets/unitedstates.png";
import ESFlag from "../assets/esspain.png";
import FRFlag from "../assets/france.png";
import ARFlag from "../assets/arabe.png";

const backendUrl = getBackendUrl();
const drawerWidth = 240;


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 56px)",
    },
    backgroundColor: theme.palette.fancyBackground,
    "& .MuiButton-outlinedPrimary": {
      color: theme.palette.primary.main, // Usa cor do tema
      border: `1px solid ${theme.palette.primary.main}40`,
      borderRadius: "8px",
      fontWeight: 600,
      textTransform: "none",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: `${theme.palette.primary.main}10`,
        borderColor: theme.palette.primary.main,
        transform: "translateY(-1px)",
        boxShadow: `0 4px 12px ${theme.palette.primary.main}30`,
      },
    },
    "& .MuiTab-textColorPrimary.Mui-selected": {
      color: theme.palette.primary.main, // Usa cor do tema
      fontWeight: 700,
    },
  },

  chip: {
    background: "red",
    color: "white",
  },

  avatar: {
    width: "100%",
  },

  toolbar: {
    paddingRight: 20,
    color: theme.palette.type === "light" ? "#1E293B" : "#F8FAFC",
    backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#16191E",
    borderBottom: theme.palette.type === "light"
      ? "1px solid #E2E8F0"
      : "1px solid rgba(255, 255, 255, 0.08)",
    boxShadow: theme.palette.type === "light"
      ? "0 1px 3px rgba(0, 0, 0, 0.04)"
      : "0 2px 8px rgba(0, 0, 0, 0.25)",
    transition: "all 0.3s ease",
    minHeight: "64px",
    [theme.breakpoints.down("sm")]: {
      minHeight: "56px",
      paddingRight: 12,
    },
    "& .MuiIconButton-root": {
      padding: 8,
      margin: "0 2px",
      borderRadius: "8px",
      color: theme.palette.type === "light" ? "#64748B" : "#94A3B8",
      transition: "all 0.2s ease",
      "& svg": {
        fontSize: "20px",
      },
      "&:hover": {
        backgroundColor: theme.palette.type === "light"
          ? `${theme.palette.primary.main}14`
          : `${theme.palette.primary.main}26`,
        color: theme.palette.primary.main,
        boxShadow: "none",
      }
    },
    "& .MuiBadge-badge": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText || "#fff",
      boxShadow: "none",
      fontSize: "0.72rem",
      height: 18,
      minWidth: 18,
    },
    "& .MuiBadge-dot": {
      height: 10,
      minWidth: 10,
      width: 10,
      borderRadius: "50% !important",
      backgroundColor: "#10B981 !important",
      boxShadow: theme.palette.type === "light"
        ? "0 0 0 2px #FFFFFF !important"
        : "0 0 0 2px #16191E !important",
    }
  },

  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 8px",
    minHeight: "64px",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      height: "56px",
      minHeight: "56px",
    },
    // ALTERAÇÃO: Removido o gradiente e definido fundo branco
    backgroundColor: "#ffffff", // Fundo branco fixo
    borderBottom: `1px solid ${theme.palette.divider}`, // Linha sutil para separação
    transition: "all 0.3s ease",
  },

  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#16191E",
    boxShadow: theme.palette.type === "light"
      ? "0 1px 3px rgba(0, 0, 0, 0.04)"
      : "0 2px 8px rgba(0, 0, 0, 0.25)",
  },

  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  menuButtonHidden: {
    display: "none",
  },

  title: {
    flexGrow: 1,
    flexShrink: 1,
    minWidth: "50px",
    fontSize: 15,
    color: theme.palette.type === "light" ? "#1E293B" : "#F8FAFC",
    fontWeight: 600,
    letterSpacing: "0.02em",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("sm")]: {
      fontSize: 13,
      maxWidth: "100px",
    }
  },

  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
    overflowY: "hidden",
    borderRight: theme.palette.type === "light" ? "1px solid #E2E8F0" : "none",
    backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#16191E",
    boxShadow: theme.palette.type === "light" ? "1px 0 4px rgba(0,0,0,0.05)" : "2px 0 8px rgba(0,0,0,0.2)",
  },

  drawerPaperClose: {
    overflowX: "hidden",
    overflowY: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },

  appBarSpacer: {
    minHeight: "64px",
    [theme.breakpoints.down("sm")]: {
      minHeight: "56px",
    },
  },

  content: {
    flex: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    padding: 0,
    margin: 0,
  },

  container: {
    padding: 0,
    margin: 0,
    maxWidth: "none",
    width: "100%",
  },

  rightToolbarBox: {
    display: "flex",
    marginLeft: "auto",
    minWidth: 0,
    flexShrink: 0,
    justifyContent: "flex-end",
    alignItems: "center",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "& > *": {
      flexShrink: 0,
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
    }
  },

  containerWithScroll: {
    flex: 1,
    overflowY: "auto", // Better native scroll behavior
    overflowX: "hidden",
    ...theme.scrollbarStyles,
    borderRadius: "0", // Reset border radius for full container
    border: "none",
    paddingTop: "8px", // Space for top items

    // Modern Thin Scrollbar
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.mode === "light" ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: theme.mode === "light" ? "rgba(0,0,0,0.2)" : "rgba(255,255,255,0.2)",
    },
  },

  NotificationsPopOver: {
    // Mantém original
  },

  logo: {
    width: "100%",
    height: "45px",
    maxWidth: 180,
    [theme.breakpoints.down("sm")]: {
      width: "auto",
      height: "100%",
      maxWidth: 180,
    },
    logo: theme.logo,
    content:
      "url(" +
      (theme.mode === "light"
        ? theme.calculatedLogoLight()
        : theme.calculatedLogoDark()) +
      ")",
    transition: "all 0.3s ease", // Transição suave
    "&:hover": {
      transform: "scale(1.02)", // Pequeno zoom no hover
    },
  },

  hideLogo: {
    display: "none",
  },

  avatar2: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    cursor: "pointer",
    borderRadius: "50%",
    border: "2px solid #ccc",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      borderColor: theme.palette.primary.main, // Usa cor do tema
    },
  },

  updateDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  // Botões da toolbar melhorados
  toolbarButton: {
    color: "rgba(255, 255, 255, 0.9)",
    borderRadius: "8px",
    padding: "8px",
    margin: "0 2px",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      transform: "translateY(-1px)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
  },

  // Menu hambúrguer com animação sutil
  menuButton: {
    color: "white",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
    "& .MuiSvgIcon-root": {
      transition: "transform 0.3s ease",
    },
    "&:hover .MuiSvgIcon-root": {
      transform: "rotate(90deg)",
    },
  },

  // Seletor de idioma melhorado
  languageSelector: {
    position: "relative",
    display: "inline-block",
    "& > button": {
      background: "rgba(255, 255, 255, 0.1)",
      border: "none",
      borderRadius: "8px",
      color: "rgba(255, 255, 255, 0.9)",
      fontSize: "18px",
      padding: "8px 12px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      "&:hover": {
        background: "rgba(255, 255, 255, 0.2)",
        transform: "translateY(-1px)",
      },
    },
    "& > div": {
      position: "absolute",
      top: "45px",
      left: "0",
      background: "#fff",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      borderRadius: "8px",
      padding: "8px",
      zIndex: 1000,
      minWidth: "120px",
      "& button": {
        background: "none",
        border: "none",
        color: "#374151",
        display: "block",
        width: "100%",
        padding: "8px 12px",
        textAlign: "left",
        borderRadius: "6px",
        fontSize: "14px",
        fontWeight: 500,
        transition: "all 0.2s ease",
        "&:hover": {
          background: `${theme.palette.primary.main}10`, // Usa cor do tema
          color: theme.palette.primary.main, // Usa cor do tema
          transform: "none",
        },
      },
    },
  },

  // Badge animado
  animatedBadge: {
    "& .MuiBadge-badge": {
      animation: "$heartbeat 2s infinite",
    },
  },

  // Language Popover Styles
  languagePopover: {
    padding: theme.spacing(2),
    width: 360,
    borderRadius: 16,
    background: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(10px)",
  },
  languageHeader: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: theme.spacing(2),
    position: "relative",
  },
  languageIconBox: {
    width: 48,
    height: 48,
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(2),
    color: "white",
  },
  languageTitle: {
    fontWeight: 700,
    fontSize: "1.1rem",
    color: "#2d3748",
    whiteSpace: "nowrap", // Prevent line break
  },
  languageSubtitle: {
    fontSize: "0.85rem",
    color: "#718096",
  },
  closeButton: {
    marginLeft: "auto", // Push to right
    color: "#a0aec0",
    background: "#EDF2F7",
    borderRadius: "50%",
    padding: 6,
    "&:hover": {
      background: "#E2E8F0",
      color: "#2D3748",
    },
  },
  languageList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
  },
  languageItem: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1, 2),
    borderRadius: 12,
    border: "1px solid #e2e8f0", // Default border
    background: "white",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#cbd5e0",
      background: "#f7fafc",
    },
  },
  languageItemActive: {
    border: "2px solid #4299e1", // Blue border for active
    background: "rgba(66, 153, 225, 0.1)", // Light blue background
    "&:hover": {
      background: "rgba(66, 153, 225, 0.15)",
    },
  },
  languageItemFlag: {
    width: 30,
    height: 20,
    borderRadius: 4,
    marginRight: theme.spacing(2),
    boxShadow: "0 1px 2px rgba(0,0,0,0.1)", // Reduced shadow
    border: "1px solid #eee", // Light border to frame the flag
    objectFit: "cover", // Force uniform rectangular size (30x20)
    display: "block",
    backgroundColor: "#fff", // Ensure transparent areas look clean
  },
  languageItemLabel: {
    flex: 1,
    fontWeight: 600,
    color: "#2d3748",
  },
  languageItemCheck: {
    color: "#fff",
    width: 20,
    height: 20,
    background: "#4299e1",
    borderRadius: "50%",
    padding: 2,
    display: "flex", // Ensure icon is centered
    alignItems: "center",
    justifyContent: "center",
  },

  "@keyframes heartbeat": {
    "0%": { transform: "scale(1)" },
    "14%": { transform: "scale(1.1)" },
    "28%": { transform: "scale(1)" },
    "42%": { transform: "scale(1.1)" },
    "70%": { transform: "scale(1)" },
  },
}));

const StyledBadge = withStyles((theme) => ({
  badge: {
    borderRadius: "50% !important",
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

const SmallAvatar = withStyles((theme) => ({
  root: {
    width: 22,
    height: 22,
    border: `2px solid ${theme.palette.background.paper}`,
  },
}))(Avatar);

const LoggedInLayout = ({ children, themeToggle, hideMenu = false }) => {
  const history = useHistory();
  const classes = useStyles();
  const [, setForceUpdate] = useState(Date.now());
  const [userModalOpen, setUserModalOpen] = useState(false);

  useEffect(() => {
    const handleLanguageChanged = () => {
      setForceUpdate(Date.now());
    };
    i18n.on("languageChanged", handleLanguageChanged);
    return () => {
      i18n.off("languageChanged", handleLanguageChanged);
    };
  }, []);
  const [anchorEl, setAnchorEl] = useState(null);
  const [langAnchorEl, setLangAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const { handleLogout, loading, user, socket } = useContext(AuthContext);
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerVariant, setDrawerVariant] = useState("permanent");
  const [drawerPinned, setDrawerPinned] = useState(false);
  const hoverTimeoutRef = useRef(null);

  // Auto-contraer al hacer clic en una opción (cambio de ruta)
  useEffect(() => {
    if (drawerOpen && !drawerPinned) {
      setDrawerOpen(false);
    }
  }, [location.pathname]);

  const handleDrawerMouseEnter = () => {
    if (!drawerOpen && drawerVariant === "permanent") {
      if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
      setDrawerOpen(true);
    }
  };

  const handleDrawerMouseLeave = () => {
    if (drawerOpen && !drawerPinned && drawerVariant === "permanent") {
      if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = setTimeout(() => {
        setDrawerOpen(false);
      }, 250);
    }
  };

  const toggleDrawer = () => {
    if (drawerOpen) {
      setDrawerPinned(false);
      setDrawerOpen(false);
    } else {
      setDrawerPinned(true);
      setDrawerOpen(true);
    }
  };

  useEffect(() => {
    return () => {
      if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    };
  }, []);

  const [showOptions, setShowOptions] = useState(false);
  const [showAnnouncementsModal, setShowAnnouncementsModal] = useState(false);
  const [announcements, setAnnouncements] = useState([]);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [showBirthdayModal, setShowBirthdayModal] = useState(false);

  const theme = useTheme();
  const { colorMode } = useContext(ColorModeContext);
  const greaterThenSm = useMediaQuery(theme.breakpoints.up("sm"));

  const [volume, setVolume] = useState(localStorage.getItem("volume") || 1);

  const { dateToClient } = useDate();
  const [profileUrl, setProfileUrl] = useState(null);
  const [updateInProgress, setUpdateInProgress] = useState(false);


  // eslint-disable-next-line react-hooks/exhaustive-deps
  const mainListItems = useMemo(
    () => <MainListItems drawerOpen={drawerOpen} collapsed={!drawerOpen} />,
    [user, drawerOpen]
  );

  const settings = useSettings();

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const { data } = await api.get("/announcements/for-company", {
          params: {
            status: true,
            pageNumber: "1"
          }
        });

        // Filtra apenas os informativos ativos e não expirados
        const activeAnnouncements = data.records.filter(announcement => {
          const isActive = announcement.status === true || announcement.status === "true";
          const isNotExpired = !announcement.expiresAt || new Date(announcement.expiresAt) > new Date();
          return isActive && isNotExpired;
        });

        setAnnouncements(activeAnnouncements);

        // Mostra o modal apenas se houver informativos ativos
        if (activeAnnouncements.length > 0) {
          const hasSeen = sessionStorage.getItem("announcementsSeen");
          if (!hasSeen) {
            setShowAnnouncementsModal(true);
            sessionStorage.setItem("announcementsSeen", "true");
          }
        }
      } catch (err) {
        toastError(err);
      }
    };

    if (user?.id) {
      fetchAnnouncements();
    }
  }, [user?.id]);

  useEffect(() => {
    // if (localStorage.getItem("public-token") === null) {
    //   handleLogout()
    // }

    if (document.body.offsetWidth > 600) {
      if (user.defaultMenu === "closed") {
        setDrawerOpen(false);
      } else {
        setDrawerOpen(true);
      }
    }
    if (user.defaultTheme && colorMode.setMode && colorMode.mode !== user.defaultTheme) {
      colorMode.setMode(user.defaultTheme);
    }
    const targetUserColor = user.color || "#10B981";
    if (colorMode.setPrimaryColorLight) {
      colorMode.setPrimaryColorLight(targetUserColor);
    }
    if (colorMode.setPrimaryColorDark) {
      colorMode.setPrimaryColorDark(targetUserColor);
    }
  }, [user.defaultMenu, document.body.offsetWidth]);

  useEffect(() => {
    if (document.body.offsetWidth < 600) {
      setDrawerVariant("temporary");
    } else {
      setDrawerVariant("permanent");
    }
  }, [drawerOpen]);

  useEffect(() => {
    const companyId = user?.companyId;

    if (companyId) {
      const buildProfileUrl = () => {
        const savedProfileImage = localStorage.getItem("profileImage");
        const currentProfileImage = savedProfileImage || user.profileImage;

        if (currentProfileImage) {
          return `${backendUrl}/public/company${companyId}/user/${currentProfileImage}`;
        }
        return `${backendUrl}/public/app/noimage.png`;
      };

      setProfileUrl(buildProfileUrl());
    }
  }, [user?.companyId, user?.profileImage, backendUrl]);

  // Callbacks dos eventos
  const handleAuthEvent = useCallback((data) => {
    if (data.user.id === +user?.id) {
      toastError(i18n.t("auth.toasts.accountAccessedOtherComputer"));
      setTimeout(() => {
        localStorage.clear();
        window.location.reload();
      }, 4000);
    }
  }, [user?.id]);

  const handleUserUpdate = useCallback((data) => {
    if (data.action === "update" && data.user.id === +user?.id) {
      if (data.user.profileImage) {
        const newProfileUrl = `${backendUrl}/public/company${user?.companyId}/user/${data.user.profileImage}`;
        setProfileUrl(newProfileUrl);
        localStorage.setItem("profileImage", data.user.profileImage);
      }
    }
  }, [user?.companyId, user?.id, backendUrl]);

  // Callbacks para eventos de aniversário
  const handleUserBirthday = useCallback((data) => {
    if (data.userId === +user?.id) {
      setShowBirthdayModal(true);
    }
  }, [user?.id]);

  const handleContactBirthday = useCallback((data) => {
    // Para contatos, apenas logamos por enquanto
    // A mensagem já foi enviada automaticamente pelo backend
  }, []);

  // Verificar aniversários no login
  const checkBirthdaysOnLogin = useCallback(async () => {
    if (user?.id && user?.companyId) {
      try {
        const { data } = await api.get("/birthdays/today");
        const birthdayData = data.data;

        // Verificar se o usuário atual faz aniversário hoje
        const userBirthday = birthdayData.users.find(u => u.id === +user.id);
        if (userBirthday) {
          setShowBirthdayModal(true);
        }

        // Se há aniversariantes, mostrar notificação
        if (birthdayData.users.length > 0 || birthdayData.contacts.length > 0) {
        }
      } catch (error) {
        console.error("Erro ao verificar aniversários:", error);
      }
    }
  }, [user?.id, user?.companyId]);

  // Registrar listeners
  useSocketListener(socket, user, 'auth', handleAuthEvent);
  useSocketListener(socket, user, 'user', handleUserUpdate);
  useSocketListener(socket, user, 'user-birthday', handleUserBirthday);
  useSocketListener(socket, user, 'contact-birthday', handleContactBirthday);

  // Verificar aniversários quando o usuário faz login
  useEffect(() => {
    if (user?.id && user?.companyId) {
      // Pequeno delay para garantir que o socket esteja conectado
      const timer = setTimeout(() => {
        checkBirthdaysOnLogin();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [user?.id, user?.companyId, checkBirthdaysOnLogin]);

  // Status do usuário
  useEffect(() => {
    if (socket?.emit && user?.companyId) {
      socket.emit("userStatus");

      const interval = setInterval(() => {
        socket?.emit && socket.emit("userStatus");
      }, 1000 * 60 * 5);

      return () => clearInterval(interval);
    }
  }, [socket, user?.companyId]);

  const handleUpdateStart = () => {
    setUpdateInProgress(true);
  };

  const handleUpdateComplete = () => {
    setUpdateInProgress(false);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const handleOpenUserModal = () => {
    setUserModalOpen(true);
    handleCloseMenu();
  };

  const handleClickLogout = () => {
    handleCloseMenu();
    handleLogout();
  };

  const drawerClose = () => {
    if (document.body.offsetWidth < 600 || user.defaultMenu === "closed") {
      setDrawerOpen(false);
    }
  };

  const handleRefreshPage = () => {
    window.location.reload(false);
  };

  const handleMenuItemClick = () => {
    const { innerWidth: width } = window;
    if (width <= 600) {
      setDrawerOpen(false);
    }
  };

  const handleLanguageChange = async (lng) => {
    try {
      if (user?.id) {
        await api.put(`/users/${user.id}`, { language: lng });
      }
    } catch (e) {
      console.error(e);
    }
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  const LANGUAGE_OPTIONS = [
    { code: "pt-BR", label: "Português", icon: BRFlag },
    { code: "en", label: "English", icon: USFlag },
    { code: "es", label: "Español", icon: ESFlag },
    { code: "fr", label: "Français", icon: FRFlag },
    { code: "ar", label: "عربي", icon: ARFlag },
  ];

  const handleStopImpersonation = async () => {
    let adminToken = localStorage.getItem("adminToken");

    if (!adminToken) {
      localStorage.removeItem("token");
      localStorage.removeItem("companyDueDate");
      localStorage.removeItem("isImpersonating");
      window.location.href = "/login";
      return;
    }

    // Ensure we parse the token if it's stored as JSON string (with quotes)
    try {
      const parsed = JSON.parse(adminToken);
      if (typeof parsed === 'string') {
        adminToken = parsed;
      }
    } catch (e) {
      // It was already a raw string, ignore
    }

    try {
      const { data } = await api.post("/auth/restore_session", { token: adminToken });

      // Update local storage with the confirmed admin session
      localStorage.setItem("token", JSON.stringify(data.token));
      localStorage.removeItem("adminToken");
      localStorage.removeItem("isImpersonating");
      localStorage.removeItem("companyDueDate");

      // Reload to root to re-initialize app with correct cookie
      window.location.href = "/";

    } catch (err) {
      console.error("Failed to restore admin session:", err);
      localStorage.removeItem("token");
      localStorage.removeItem("companyDueDate");
      localStorage.removeItem("isImpersonating");
      localStorage.removeItem("adminToken");
      window.location.href = "/login";
    }
  };

  const [enabledLanguages, setEnabledLanguages] = useState(["pt-BR", "en", "es", "fr", "ar"]);
  const { getAll } = useSettings();
  useEffect(() => {
    async function fetchSettings() {
      if (!user?.companyId) return;
      try {
        const settings = await getAll();
        const enabledLanguagesSetting = settings.find(
          (s) => s.key === "enabledLanguages"
        )?.value;
        let langs = ["pt-BR", "en", "es", "fr", "ar"];
        try {
          if (enabledLanguagesSetting) {
            langs = JSON.parse(enabledLanguagesSetting);
          }
        } catch { }
        setEnabledLanguages(langs);
      } catch (error) {
        console.log("Layout - erro ao carregar enabledLanguages:", error);
      }
    }
    fetchSettings();
  }, [user?.companyId]);

  const filteredLanguageOptions = LANGUAGE_OPTIONS.filter((lang) =>
    enabledLanguages.includes(lang.code)
  );

  if (loading || updateInProgress) {
    return <BackdropLoading />;
  }

  return (
    <div className={clsx(classes.root, "logged-in-layout")}>
      {!hideMenu && (
        <Drawer
          variant={drawerVariant}
          className={drawerOpen ? classes.drawerPaper : classes.drawerPaperClose}
          classes={{
            paper: clsx(
              classes.drawerPaper,
              !drawerOpen && classes.drawerPaperClose
            ),
          }}
          open={drawerOpen}
          onMouseEnter={handleDrawerMouseEnter}
          onMouseLeave={handleDrawerMouseLeave}
        >
          <div className={classes.toolbarIcon} style={{ justifyContent: "flex-end" }}>
            <img
              className={drawerOpen ? classes.logo : classes.hideLogo}
              style={{
                display: "block",
                position: "absolute",
                left: drawerOpen ? "15px" : "50%",
                transform: drawerOpen ? "none" : "translateX(-50%)",
                height: "auto",
                maxHeight: "45px",
                maxWidth: "180px",
                objectFit: "contain",
              }}
              alt="logo"
            />
            <IconButton 
              onClick={toggleDrawer} 
              size="small"
              style={{ zIndex: 10, backgroundColor: "rgba(0,0,0,0.08)", marginRight: 4, padding: 8, color: theme.palette.primary.main }}
            >
              <ChevronLeftIcon fontSize="small" />
            </IconButton>
          </div>
          <List className={classes.containerWithScroll}>
            {/* {mainListItems} */}
            <MainListItems collapsed={!drawerOpen} />
          </List>
          <Divider />
        </Drawer>
      )}

      <AppBar
        position="absolute"
        className={clsx(classes.appBar, !hideMenu && drawerOpen && classes.appBarShift)}
        color="primary"
      >
        <Toolbar className={classes.toolbar}>
          {!hideMenu && (
            <Tooltip title="Menú" arrow placement="bottom">
              <IconButton
                edge="start"
                aria-label="open drawer"
                style={{ color: theme.palette.type === "light" ? "#475569" : "#FFFFFF" }}
                onClick={toggleDrawer}
                className={clsx(drawerOpen && classes.menuButtonHidden)}
              >
                <MenuIcon />
              </IconButton>
            </Tooltip>
          )}

          <Typography
            component="h2"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            {greaterThenSm ? (
              <>
                {i18n.t("mainDrawer.appBar.user.message")}{" "}
                <b style={{ color: theme.palette.primary.main }}>{user.name}</b>
                {user?.name !== user?.company?.name && !user?.super && (
                  <>
                    ,{" "}{i18n.t("mainDrawer.appBar.user.messageEnd")}{" "}
                    <b>{user?.company?.name}</b>
                  </>
                )}! 
                {user?.company?.plan && (
                  <span
                    style={{
                      marginLeft: 10,
                      fontSize: '0.78rem',
                      color: theme.palette.type === "light" ? theme.palette.primary.main : "#67e8f9",
                      backgroundColor: theme.palette.type === "light" ? `${theme.palette.primary.main}14` : "rgba(6, 182, 212, 0.15)",
                      border: `1px solid ${theme.palette.type === "light" ? `${theme.palette.primary.main}33` : "rgba(6, 182, 212, 0.3)"}`,
                      padding: "2px 8px",
                      borderRadius: "6px",
                      fontWeight: 600,
                      display: "inline-block",
                      verticalAlign: "middle"
                    }}
                  >
                    Plan: <b>{user?.company?.plan?.name}</b>
                  </span>
                )}
                {user?.company?.dueDate && (
                  <span
                    style={{
                      marginLeft: 8,
                      fontSize: '0.78rem',
                      color: theme.palette.type === "light" ? "#64748B" : "#94A3B8",
                      backgroundColor: theme.palette.type === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.06)",
                      border: `1px solid ${theme.palette.type === "light" ? "#E2E8F0" : "rgba(255,255,255,0.1)"}`,
                      padding: "2px 8px",
                      borderRadius: "6px",
                      fontWeight: 500,
                      display: "inline-block",
                      verticalAlign: "middle"
                    }}
                  >
                    {i18n.t("mainDrawer.appBar.user.active")}{" "}
                    {dateToClient(user?.company?.dueDate)}
                  </span>
                )}
              </>
            ) : (
              <>
                {i18n.t("mainDrawer.appBar.user.message")}{" "}
                <b style={{ color: theme.palette.primary.main }}>{user.name}</b>
                {user?.name !== user?.company?.name && !user?.super && (
                  <>
                    ,{" "}{i18n.t("mainDrawer.appBar.user.messageEnd")}{" "}
                    <b>{user?.company?.name}</b>
                  </>
                )}!
              </>
            )}
          </Typography>

          <div className={classes.rightToolbarBox}>
          {!hideMenu && (
            <>
              {user?.company && (() => {
                const rawCredits = parseFloat(user.company.aiCredits || 0);
                const exactCreditsStr = rawCredits.toFixed(6);
                const displayCredits = rawCredits > 0 && rawCredits < 0.05
                  ? rawCredits.toFixed(4)
                  : rawCredits.toFixed(2);

                return (
                  <Tooltip
                    title={i18n.t("layout.tooltips.aiBalance", { balance: exactCreditsStr })}
                    arrow
                    placement="bottom"
                  >
                    <div
                      style={{
                        marginRight: 10,
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6,
                        height: 32,
                        padding: '0 10px',
                        borderRadius: 16,
                        cursor: 'pointer',
                        backgroundColor: theme.palette.type === "light"
                          ? "rgba(16, 185, 129, 0.08)"
                          : "rgba(16, 185, 129, 0.16)",
                        border: `1px solid ${
                          theme.palette.type === "light"
                            ? "rgba(16, 185, 129, 0.35)"
                            : "rgba(16, 185, 129, 0.45)"
                        }`,
                        color: theme.palette.type === "light" ? "#047857" : "#34D399",
                        fontWeight: 700,
                        fontSize: "0.82rem",
                        transition: "all 0.2s ease",
                        flexShrink: 0,
                        whiteSpace: 'nowrap',
                        boxShadow: "0 1px 2px rgba(0,0,0,0.04)"
                      }}
                      onClick={() => history.push("/financeiro")}
                    >
                      <span style={{ fontSize: "14px", lineHeight: 1 }}>⚡</span>
                      <span>
                        {i18n.t("layout.aiBalance")}${displayCredits} USD
                      </span>
                    </div>
                  </Tooltip>
                );
              })()}

              {localStorage.getItem("isImpersonating") && (
                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={handleStopImpersonation}
                  startIcon={<ExitToAppIcon />}
                  style={{ marginRight: 8, borderColor: theme.palette.type === "light" ? "#CBD5E1" : "rgba(255,255,255,0.3)" }}
                >
                  Volver a Admin
                </Button>
              )}

              <VersionControl
                onUpdateStart={handleUpdateStart}
                onUpdateComplete={handleUpdateComplete}
              />

              <Tooltip
                title={theme.palette.type === "dark" ? i18n.t("layout.tooltips.themeLight") : i18n.t("layout.tooltips.themeDark")}
                arrow
                placement="bottom"
              >
                <IconButton
                  size="small"
                  aria-label="Toggle theme mode"
                  color="inherit"
                  onClick={colorMode.toggleColorMode}
                >
                  {theme.palette.type === "dark" ? (
                    <Brightness7Icon style={{ fontSize: 20 }} />
                  ) : (
                    <Brightness4Icon style={{ fontSize: 20 }} />
                  )}
                </IconButton>
              </Tooltip>

              <Tooltip
                title={i18n.t("layout.tooltips.volume")}
                arrow
                placement="bottom"
              >
                <div>
                  <NotificationsVolume setVolume={setVolume} volume={volume} />
                </div>
              </Tooltip>

              <Tooltip
                title={i18n.t("layout.tooltips.refresh")}
                arrow
                placement="bottom"
              >
                <IconButton
                  onClick={handleRefreshPage}
                  aria-label={i18n.t("layout.tooltips.refresh")}
                  color="inherit"
                  size="small"
                >
                  <CachedIcon style={{ fontSize: 20 }} />
                </IconButton>
              </Tooltip>

              <PlanLimitsSiren />

              {user.id && (
                <Tooltip
                  title={i18n.t("layout.tooltips.notifications")}
                  arrow
                  placement="bottom"
                >
                  <div>
                    <NotificationsPopOver volume={volume} />
                  </div>
                </Tooltip>
              )}

              <Tooltip
                title={i18n.t("layout.tooltips.announcements")}
                arrow
                placement="bottom"
              >
                <div>
                  <AnnouncementsPopover />
                </div>
              </Tooltip>

              <Tooltip
                title={i18n.t("layout.tooltips.chat")}
                arrow
                placement="bottom"
              >
                <div>
                  <ChatPopover />
                </div>
              </Tooltip>
            </>
          )}
          
          <div className="language-dropdown">
            <Tooltip
              title={i18n.t("layout.tooltips.language")}
              arrow
              placement="bottom"
            >
              <button
                onClick={(e) => setLangAnchorEl(e.currentTarget)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "0 8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {(() => {
                  const currentLang = LANGUAGE_OPTIONS.find(l => i18n.language.startsWith(l.code) || l.code.startsWith(i18n.language)) || LANGUAGE_OPTIONS[0];
                  return (
                    <div style={{
                      width: 28,
                      height: 28,
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: theme.palette.type === "light" ? "1.5px solid #CBD5E1" : "1.5px solid rgba(255,255,255,0.2)",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "3px",
                      background: theme.palette.type === "light" ? "#F8FAFC" : "#1E293B",
                    }}>
                      <img
                        src={currentLang.icon}
                        alt={currentLang.label}
                        style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: "50%" }}
                      />
                    </div>
                  );
                })()}
              </button>
            </Tooltip>
            <Popover
              id="language-popover"
              open={Boolean(langAnchorEl)}
              anchorEl={langAnchorEl}
              onClose={() => setLangAnchorEl(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              classes={{ paper: classes.languagePopover }}
            >
              <div className={classes.languageHeader}>
                <div className={classes.languageIconBox}>
                  <TranslateIcon style={{ fontSize: 24 }} />
                </div>
                <div style={{ marginRight: 16 }}>
                  <Typography className={classes.languageTitle}>
                    {i18n.t("layout.languageModal.title")}
                  </Typography>
                  <Typography className={classes.languageSubtitle}>
                    {i18n.t("layout.languageModal.subtitle")}
                  </Typography>
                </div>
                <IconButton
                  className={classes.closeButton}
                  onClick={() => setLangAnchorEl(null)}
                  size="small"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>

              <div className={classes.languageList}>
                {filteredLanguageOptions.map((lang) => {
                  const isActive = i18n.language === lang.code;
                  return (
                    <div
                      key={lang.code}
                      className={clsx(classes.languageItem, {
                        [classes.languageItemActive]: isActive,
                      })}
                      onClick={() => {
                        handleLanguageChange(lang.code);
                        setLangAnchorEl(null);
                      }}
                    >
                      <img
                        src={lang.icon}
                        alt={lang.label}
                        className={classes.languageItemFlag}
                      />
                      <Typography className={classes.languageItemLabel}>
                        {lang.label}
                      </Typography>
                      {isActive && (
                        <div className={classes.languageItemCheck}>
                          <CheckIcon style={{ fontSize: 16, color: "#fff" }} />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </Popover>
          </div>

          <div className="user-menu-wrapper">
            <Tooltip
              title={i18n.t("layout.tooltips.profile")}
              arrow
              placement="bottom"
            >
              <div>
                <StyledBadge
                  overlap="circular"
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  variant="dot"
                  onClick={handleMenu}
                  style={{ cursor: "pointer" }}
                >
                  <Avatar
                    alt={user.name || "User"}
                    className={classes.avatar2}
                    src={profileUrl}
                    style={{
                      width: 32,
                      height: 32,
                      border: theme.palette.type === "light"
                        ? `2px solid ${theme.palette.primary.main}40`
                        : `2px solid ${theme.palette.primary.main}60`
                    }}
                  />
                </StyledBadge>
              </div>
            </Tooltip>


            <UserModal
              open={userModalOpen}
              onClose={() => setUserModalOpen(false)}
              onImageUpdate={(newProfileUrl) => setProfileUrl(newProfileUrl)}
              userId={user?.id}
            />

            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={menuOpen}
              onClose={handleCloseMenu}
              PaperProps={{
                style: {
                  minWidth: "150px",
                  maxWidth: "200px",
                  width: "auto",
                },
              }}
            >
              <MenuItem onClick={handleOpenUserModal}>
                {i18n.t("mainDrawer.appBar.user.profile")}
              </MenuItem>
              <MenuItem onClick={handleClickLogout}>
                {i18n.t("mainDrawer.appBar.user.logout")}
              </MenuItem>
            </Menu>
          </div>
          </div>

        </Toolbar>
      </AppBar >
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        {children ? children : null}
      </main>

      {/* Modal de Informativos */}
      <Dialog
        open={showAnnouncementsModal}
        onClose={() => setShowAnnouncementsModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{i18n.t("announcements.title")}</DialogTitle>
        <DialogContent dividers>
          {selectedAnnouncement ? (
            <div>
              <Typography variant="h6" gutterBottom>
                {selectedAnnouncement.title}
              </Typography>
              <Typography variant="body1" style={{ whiteSpace: 'pre-line' }}>
                {selectedAnnouncement.text}
              </Typography>
              {selectedAnnouncement.mediaPath && (
                <div style={{ marginTop: 16 }}>
                  <img
                    src={`${backendUrl}/public/company${user.companyId}${selectedAnnouncement.mediaPath}`}
                    alt="Anexo"
                    style={{ maxWidth: '100%' }}
                  />
                </div>
              )}
              <Button
                onClick={() => setSelectedAnnouncement(null)}
                style={{ marginTop: 16 }}
                variant="outlined"
              >
                {i18n.t("announcements.buttons.back")}
              </Button>
            </div>
          ) : (
            <List>
              {announcements.map((announcement) => (
                <ListItem
                  button
                  key={announcement.id}
                  onClick={() => setSelectedAnnouncement(announcement)}
                >
                  <ListItemAvatar>
                    <Avatar>
                      <NotificationsIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={announcement.title}
                    secondary={
                      <>
                        <Typography
                          component="span"
                          variant="body2"
                          color="textPrimary"
                        >
                          {i18n.t("announcements.priority.priority")}: {
                            announcement.priority === 1
                              ? i18n.t("announcements.priority.high")
                              : announcement.priority === 2
                                ? i18n.t("announcements.priority.medium")
                                : i18n.t("announcements.priority.low")
                          }
                        </Typography>
                        {` — ${new Date(announcement.createdAt).toLocaleDateString()}`}
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowAnnouncementsModal(false);
              setSelectedAnnouncement(null);
            }}
            color="primary"
          >
            {i18n.t("announcements.buttons.close")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Aniversário */}
      <BirthdayModal
        open={showBirthdayModal}
        onClose={() => setShowBirthdayModal(false)}
        user={user}
      />

    </div >
  );
};

export default LoggedInLayout;
